"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "narni": {
    "7743643a": [{
      "hkey": "6ed9ceef",
      "slug": "narni-scalo",
      "name": "Narni Scalo",
      "primary": true,
      "skipSearch": false
    }],
    "la-cerqua": [{
      "hkey": "6ed9ceef",
      "slug": "narni-scalo",
      "name": "Narni Scalo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "narni"
    }],
    "1b88ef21": [{
      "hkey": "8d9e119a",
      "slug": "montoro-nera-montoro",
      "name": "Montoro-Nera Montoro",
      "primary": true,
      "skipSearch": false
    }],
    "montoro": [{
      "hkey": "8d9e119a",
      "slug": "montoro-nera-montoro",
      "name": "Montoro-Nera Montoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;